import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import CategoryPanel from './CategoryPanel'
import Center from '../../../../../components/helpers/Center'
import FlexGrid from '../../../../../components/structure/FlexGrid'
import IconButton from '../../../../../components/actions/IconButton'
import Separator from '../../../../../components/helpers/Separator'
import Sticky from '../../../../../components/helpers/Sticky'
import Scroll from '../../../../../components/helpers/Scroll'
import RemoveModal from '../questions/removeModal/RemoveModal'
import PlacesLoader from '../../_load/PlacesLoader'

const CategoriesList = () => {
  const { t } = useTranslation('editChecklist')
  const form = useChecklistForm()
  const { addCategory } = useChecklistFormActions()
  const { selectedCategoryIndex } = useChecklistForm()

  const questionIds = form?.categories?.[selectedCategoryIndex]?.children.map(child => child.id)

  // Single Places loader for the whole tree: `usePlaces` (in ConditionsLabel) reads
  // the nearest provider, so mounting it once here serves every condition branch.
  // Previously each logic branch mounted its own PlacesLoader, firing dozens of
  // `Places(limit: 90000)` queries and freezing the page on large tenants.
  return (
    <PlacesLoader
      noEmptyMessage
      uncontrolledChildren={
        <Sticky position="unset">
          <Scroll maxHeight="calc(100vh - 7.5rem)" overflowY="auto">
            <FlexGrid direction="column" align="stretch" justify="flex-start" padding="2rem 4rem 4rem 4rem">
              {form.categories.map((item, index) => (
                <CategoryPanel key={item.reference} category={item} index={index} />
              ))}
              <RemoveModal questionIds={questionIds} index={selectedCategoryIndex} isCategory />
              <Separator weight={6} />
              <Center>
                <IconButton icon="BsPlus" transparent label={t('addCategory')} onClick={addCategory} />
              </Center>
            </FlexGrid>
          </Scroll>
        </Sticky>
      }
    />
  )
}

export default CategoriesList
